var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearsunny(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5 58.5938C49.1498 58.5938 58.5938 49.1498 58.5938 37.5C58.5938 25.8502 49.1498 16.4062 37.5 16.4062C25.8502 16.4062 16.4062 25.8502 16.4062 37.5C16.4062 49.1498 25.8502 58.5938 37.5 58.5938Z",
    fill: "#F2B035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 60.9375C24.5766 60.9375 14.0625 50.4234 14.0625 37.5C14.0625 24.5766 24.5766 14.0625 37.5 14.0625C50.4234 14.0625 60.9375 24.5766 60.9375 37.5C60.9375 50.4234 50.4234 60.9375 37.5 60.9375ZM37.5 18.75C27.1617 18.75 18.75 27.1617 18.75 37.5C18.75 47.8383 27.1617 56.25 37.5 56.25C47.8383 56.25 56.25 47.8383 56.25 37.5C56.25 27.1617 47.8383 18.75 37.5 18.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8438 0H35.1562V9.375H39.8438V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6422 9.32646L9.32764 12.641L15.9567 19.2701L19.2712 15.9555L12.6422 9.32646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 35.1562H0V39.8438H9.375V35.1562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9567 55.7298L9.32764 62.3589L12.6422 65.6734L19.2712 59.0444L15.9567 55.7298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8438 65.625H35.1562V75H39.8438V65.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0455 55.7299L55.731 59.0444L62.36 65.6735L65.6746 62.359L59.0455 55.7299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 35.1562H65.625V39.8438H75V35.1562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.36 9.3265L55.731 15.9556L59.0455 19.2701L65.6746 12.641L62.36 9.3265Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearsunny);
export default __webpack_public_path__ + "static/media/clearsunny.805adf5c162863d81d20f439c83b012f.svg";
export { ForwardRef as ReactComponent };